import { ApplicationConfig, isDevMode, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideClientHydration } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { getDatabase, provideDatabase } from '@angular/fire/database';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { registerLocaleData } from '@angular/common';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';
import { provideTransloco } from '@jsverse/transloco';
import { TranslocoHttpLoader } from './transloco-loader';
import { UnauthInterceptor } from './shared/interceptors/unauth.interceptor';
import { environment } from 'src/environments/environment';
import { routes } from './app.routes';

import localeEn from '@angular/common/locales/en';
import localeBg from '@angular/common/locales/bg';
import { provideTranslocoMessageformat } from '@jsverse/transloco-messageformat';

// Supported languages by Angular Pipes
registerLocaleData(localeEn);
registerLocaleData(localeBg);

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(
            routes,
            withInMemoryScrolling({
                anchorScrolling: 'enabled',
                // scrollPositionRestoration: 'enabled',
            }),
        ),
        provideClientHydration(),
        provideHttpClient(withFetch()),
        provideAnimations(),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: UnauthInterceptor,
            multi: true
        }, {
            provide: LOCALE_ID,
            useValue: environment.locales.default.replace('_', '-'),
        },
        provideFirebaseApp(() => initializeApp(environment.services.firebase)),
        provideDatabase(() => getDatabase()),
        provideTransloco({
            config: {
                availableLangs: environment.locales.available?.map((item: any) => {
                    return {
                        id: item.id ?? '',
                        label: item.label ?? '',
                    }
                }),
                defaultLang: environment?.locales?.default ?? 'bg_BG',
                reRenderOnLangChange: true,
                prodMode: !isDevMode(),
            },
            loader: TranslocoHttpLoader,

        }),
        provideTranslocoMessageformat({
            locales: environment.locales.available?.map((item: any) => item.id.replace('_', '-')),
        }),
        MessageService,
        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: definePreset(Lara, {
                    semantic: {
                        primary: {
                            50: '{blue.50}',
                            100: '{blue.100}',
                            200: '{blue.200}',
                            300: '{blue.300}',
                            400: '{blue.400}',
                            500: '{blue.500}',
                            600: '{blue.600}',
                            700: '{blue.700}',
                            800: '{blue.800}',
                            900: '{blue.900}',
                            950: '{blue.950}'
                        }
                    }
                }),
                options: {
                    darkModeSelector: false,
                    order: 'primeng, app-styles'
                }
            }
        })
    ]
};
